import { isBrowser } from "browser-or-node";
const KEY = "voucher_code";

const voucherCodeCache = {
  get() {
    if (!isBrowser) return null;
    return localStorage.getItem(KEY);
  },

  set(value) {
    if (!isBrowser) return;
    localStorage.setItem(KEY, value);
  },

  remove() {
    if (!isBrowser) return;
    localStorage.removeItem(KEY);
  },
};

export default voucherCodeCache;
